import { getCompanyFormClsx, getCompanyFormId } from "../helpers";

export default function CompanyFieldset({
  heading,
  id,
  children,
}: {
  heading: string;
  id: string;
  children: React.ReactNode;
}) {
  return (
    <fieldset
      id={getCompanyFormId(id)}
      className={getCompanyFormClsx("main", id)}
    >
      {heading ? (
        <h2 className="texts__component_title--bold">{heading}</h2>
      ) : null}

      {children}
    </fieldset>
  );
}
